import { useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';

import { getLastOperationDate } from 'modules/transactions/api/getLastOperationDate';

const defaultDate = '1990-01-01T00:00';

export const useGetLastOperationDate = (societyId: string) => {
  const [lastOperationDate, setLastOperationDate] = useState<string>('');
  const [formattedLastOperationDate, setFormattedLastOperationDate] =
    useState<string>('');

  const fetchLastOperationDate = useCallback(async () => {
    if (!societyId) return;

    try {
      const response = (await getLastOperationDate(societyId)) as string;
      setLastOperationDate(response);

      const formattedResponse = format(new Date(response), 'yyyy-MM-dd');
      setFormattedLastOperationDate(formattedResponse);
    } catch (error) {
      setLastOperationDate(defaultDate);
    }
  }, [societyId]);

  useEffect(() => {
    fetchLastOperationDate();
  }, [fetchLastOperationDate]);

  return {
    data: {
      lastOperationDate,
      formattedLastOperationDate,
    },
  };
};
